<template>
  <table class="table table-borderless table-border table-align">
    <thead>
      <tr>
        <th>
          <BkpsCheckBox @input="$emit('changeCheckAllRow', $event)" :value="checkAllRow"/>
        </th>
        <th v-for="column in columns" :key="column.key" :title="column.description">
          {{ column.label }}
        </th>
        <th/>
      </tr>
    </thead>
    <tbody>
      <tr v-for="fee in fees" :key="fee.id">
        <td>
          <BkpsCheckBox v-model="fee.checked" @input="$emit('changeCheckRow', $event)"/>
        </td>
        <td v-for="column in columns" :key="column.key" class="nowrap">
          <template v-if="typeof column.method === 'function'">
            {{ column.method(fee[column.key]) }}
          </template>
          <template v-else-if="column.key === 'barcode_digits' && fee.barcode_digits">
            <button
                class="btn btn-outline btn-sm"
                @click.prevent="copyBarcode(fee.barcode_digits)"
                v-tooltip.bottom="{content: tokenClick}"
            >
              <BarcodeIcon />
            </button>
          </template>
          <template v-else-if="column.key === 'entityStatusId'">
            {{ vehicleStatusLabel(fee) }}
          </template>
          <template v-else>
            {{ fee[column.key] }}
          </template>
          <InfoIcon
              v-if="column.info && fee.value_details.length"
              size="1.5x"
              v-tooltip.auto="formatFeeDetails(fee.value_details)"
          />
        </td>

        <td>
          <Dropdown
              title-dropdown="Opções"
              class="col-md ml-2 btn-sm btn-primary"
          >
            <ul class="mb-1 mt-1">
              <template v-if="$withPolicy('cm-taxas', 'download_docs')">
                <li v-if="hasBoletoDocument(fee)" class="dropdown-item" title="Clique para baixar o boleto" @click="download(getLatestBoletoDocumentId(fee))">
                  Baixar boleto
                </li>
                <li v-else class="dropdown-item" title="Nenhum boleto disponível no momento" style="cursor: not-allowed; color: #8A9EB5;">
                  Baixar boleto
                </li>
              </template>
              <li>
                <router-link :to="`/cm-taxas/taxas/${fee.id}`" class="dropdown-item">
                  Detalhes
                </router-link>
              </li>
            </ul>
          </Dropdown>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import GetUser from '@/mixins/GetUser'
import GetAccount from '@/mixins/GetAccount'
import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'

import GlobalLoading from '@/mixins/GlobalLoading'
import Dropdown from '@/components/shares/specialTag/Dropdown'
import { InfoIcon } from 'vue-feather-icons'
import BarcodeIcon from '@/components/icons/BarcodeIcon.vue'
import { vehicleStatusRowLabel } from '@/utils/vehicleStatus'

export default {

  components: {BarcodeIcon, Dropdown, BkpsCheckBox, InfoIcon },
  mixins: [GetUser, GetAccount, GlobalLoading],
  name: 'Table',
  props: {
    checkAllRow: { required: true, type: Boolean },
    columns: { required: true, type: Array },
    entityStatusNames: { type: Object, default: () => ({}) },
    fees: { required: true, type: Array }
  },
  data: () => ({
    showModal: false,
    tokenClick: 'Clique para copiar'
  }),
  methods: {
    vehicleStatusLabel(fee) {
      return vehicleStatusRowLabel(fee, this.entityStatusNames)
    },
    formatFeeDetails(feeDetails) {
      return feeDetails.map(([key, value]) => `${this.$parse.capitalize(key)}: ${value}`).join(' | ')
    },
    openLoad() {
      this.openGlobalLoad()
    },
    closeLoad() {
      this.closeGlobalLoad()
    },
    hasBoletoDocument(fee) {
      return fee.documents && fee.documents.some(document => document.kind === 'boleto')
    },
    getLatestBoletoDocumentId(fee) {
      if (fee.documents && fee.documents.length > 0) {
        const boletoDocuments = fee.documents.filter(document => document.kind === 'boleto')
        if (boletoDocuments.length > 0) {
          const sortedDocuments = boletoDocuments.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          return sortedDocuments[0].id
        }
      }
    },
    download(documentId) {
      if (documentId) {
        this.openLoad()
        this.axios
            .get(`/maestro/documents/${documentId}/link`)
            .then(response => this.$parse.downloadByLink(response.data))
            .catch(e => this.$notify.addError(e))
            .finally(() => this.closeLoad())
      }
    },
    copyBarcode(barcode) {
      const input = document.createElement('input')
      input.value = barcode
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$notify.add('Código de barras copiado com sucesso!')
    },
  },
}
</script>

<style scoped>
.color-badge {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 4px;
  border-radius: 3px;
}
</style>
